import { render, staticRenderFns } from "./PageGroupUsers.vue?vue&type=template&id=22f6193e&scoped=true&"
import script from "./PageGroupUsers.vue?vue&type=script&lang=ts&"
export * from "./PageGroupUsers.vue?vue&type=script&lang=ts&"
import style0 from "./PageGroupUsers.vue?vue&type=style&index=0&id=22f6193e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f6193e",
  null
  
)

export default component.exports